<template>
  <section>
    <div class="action-buttons">
      <div
        class="button-add-campaign"
        v-if="!modifiedRows.length"
      >
        <button
          class="button is-success is-medium"
          id="clear"
          @click="$parent.isComponentModalActive = true"
        >
          <span>
            <i class="fal fa-plus-circle"></i> Ajouter un Objectif Quotidien
          </span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="checkedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="deleteChecked"
          :disabled="!checkedRows.length"
        >
          <span>Supprimer</span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-green is-medium"
          id="clear"
          @click="validateModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-check"></i> Valider les modifications
          </span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="cancelModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-times"></i> Annuler les modifications
          </span>
        </button>
      </div>
    </div>

    <b-modal
      :active.sync="$parent.isComponentModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 480px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Ajouter un Objectif Quotidien</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                class="b-modal-select-field"
                label="Weezy associé :"
                required
              >
                <b-select
                  :disabled="!isAdmin[0]"
                  placeholder="Choisir le weezy"
                  v-model="formWeezyId"
                  :required="true"
                >
                  <option
                    v-for="weezy in weezys"
                    :key="weezy.id"
                    :value="weezy.id"
                  >{{weezy.name}}</option>
                </b-select>
              </b-field>

              <b-field
                label="Thème de l'Objectif :"
                required
              >
                <b-select
                  placeholder="Choisir le Thème"
                  v-model="formThemeId"
                  :required="true"
                >
                  <option
                    v-for="theme in themes"
                    :key="theme.id"
                    :value="theme.id"
                  >{{theme.name}}</option>
                </b-select>
              </b-field>
            </div>

            <div class="modal-line">
              <b-field
                class="modal-input-field"
                label="Objectif de Vente :"
                required
              >
                <b-input
                  class="b-modal-input-number"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  v-model="formDailySalesGoal"
                  placeholder="Objectif"
                ></b-input>
              </b-field>

              <b-field
                class="modal-input-field"
                label="Volume Weezy :"
                required
              >
                <input
                  type="range"
                  min="1"
                  max="3"
                  v-model="formVolume"
                >
                {{getVolume(formVolume)}}
              </b-field>
            </div>

            <div class="modal-line">
              <!-- <b-field
                class="modal-input-field"
                label="Objectif Actif :"
                required
              >
                <b-switch
                  :disabled="!isWeezyActive(formWeezyId)"
                  v-model="formIsActive"
                ></b-switch>
              </b-field> -->
              <b-field
                class="modal-input-field"
                label="Vibe Sensor :"
                required
              >
                <b-switch v-model="formIsVibeSensorActive"></b-switch>
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
              :disabled="isSubmitting"
            >
              <span>
                <i class="fal fa-times"></i> Annuler
              </span>
            </button>
            <button
              class="button is-success"
              type="button"
              @click="submitFormData"
              :disabled="isSubmitting"
            >
              <span>
                <i class="fal fa-check"></i> Ajouter
              </span>
            </button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :active.sync="$parent.isDeleteConfirmationModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 480px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Confirmer la suppression ?</p>
          </header>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            >
              <span>
                <i class="fal fa-times"></i> Annuler
              </span>
            </button>
            <button
              class="button is-success"
              type="button"
              @click="confirmDelete"
            >
              <span>
                <i class="fal fa-check"></i> Confirmer
              </span>
            </button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-select
      v-model="perPage"
      style="padding-left: 20px;"
    >
      <option value="10">10 par page</option>
      <option value="20">20 par page</option>
      <option value="50">50 par page</option>
      <option value="100">100 par page</option>
    </b-select>

    <b-table
      class="b-table"
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :checked-rows.sync="checkedRows"
      :checkable="checkable"
      :selected.sync="selected"
      :isLoading="isLoading"
      paginated
      :per-page="perPage"
      :current-page.sync="currentPage"
      pagination-simple
      :mobile-cards="false"
    >
      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >{{ props.column.label }}</b-tooltip>
      </template>
      <template slot-scope="props">
        <b-table-column
          field="creation"
          label="Date de création"
          meta="Date de Création de l'Objectif"
          :sortable="true"
          :centered="true"
          :custom-sort="sortByCreation"
        >{{ dateFormatter(props.row.creation_date_time) }}</b-table-column>

        <b-table-column
          field="activation"
          label="Heure d'activation"
          meta="Heure d'Activation de l'Objectif (modifiable si objectif actif, par défaut est l'heure l'activation initiale)"
          :centered="true"
        >
          <b-timepicker
            v-model="props.row.activation_date_time"
            @input="toggleModified(props.row)"
            :max-time="getMaxTime(props.row)"
            :disabled="props.row.activation_date_time.getFullYear() == 1970"
          ></b-timepicker>
        </b-table-column>

        <b-table-column
          field="is_reached"
          :style="getColor(props.row)"
          label="Progression"
          width="60"
          meta="Ration ventes réalisées / objectif de ventes"
          :sortable="true"
          centered
          :custom-sort="sortByProgression"
        >{{ (props.row.sales.length / props.row.daily_sales_goal*100).toFixed(2)}}%</b-table-column>

        <b-table-column
          field="is_active"
          label="Actif"
          meta="Rendre l'objectif Actif / Inactif pour permettre la déclaration de ventes ou non"
          :centered="true"
          :sortable="checkable"
        >
          <b-switch
            :disabled="!isWeezyActive(props.row.weezy_id)"
            type="is-success"
            v-model="props.row.is_active"
            @input="toggleModified(props.row)"
          ></b-switch>
        </b-table-column>

        <b-table-column
          field="is_vibe_sensor_active"
          label="Vibe Sensor"
          meta="Défini si Weezy déclenche une animation lorsqu'il est déplacé, ou détecte du bruit"
          :centered="true"
          :sortable="checkable"
        >
          <b-switch
            type="is-success"
            v-model="props.row.is_vibe_sensor_active"
            @input="toggleModified(props.row)"
          ></b-switch>
        </b-table-column>

        <b-table-column
          field="sound_volume"
          label="Volume Weezy"
          width="222"
          meta="Défini le volume des animations jouées par Weezy"
          :centered="true"
          :sortable="checkable"
        >
          <input
            type="range"
            min="1"
            max="3"
            v-model="props.row.sound_volume"
            @input="toggleModified(props.row)"
          >
          {{getVolume(props.row.sound_volume)}}
        </b-table-column>

        <b-table-column
          field="weezy_id"
          label="Weezy"
          meta="Nom du Weezy auquel l'objectif est affecté"
          :centered="true"
          :sortable="true"
        >
          <b-select
            :disabled="(!isAdmin[0])"
            placeholder="Choisir le weezy"
            v-model="props.row.weezy_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option
              v-for="weezy in weezys"
              :key="weezy.id"
              :value="weezy.id"
            >{{weezy.name}}</option>
          </b-select>
        </b-table-column>

        <b-table-column
          field="theme_id"
          label="Thème"
          meta="Défini le thème associé à l'objectif"
          :centered="true"
          :sortable="true"
        >
          <b-select
            placeholder="Choisir le Thème"
            v-model="props.row.theme_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option
              v-for="theme in themes"
              :key="theme.id"
              :value="theme.id"
            >{{theme.name}}</option>
          </b-select>
        </b-table-column>

        <b-table-column
          field="daily_sales_goal"
          label="Objectif de Ventes"
          meta="Nombre de ventes à atteindre en fin de journée"
          :centered="true"
          :sortable="checkable"
        >
          <b-input
            class="b-input-number"
            type="number"
            min="0"
            oninput="this.value = Math.abs(this.value)"
            v-model="props.row.daily_sales_goal"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas d'Objectifs Quotidiens</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
export default {
  name: "GoalsTable",
  props: ["goals", "themes", "weezys", "checkable", "campaigns", "isAdmin"],
  data: () => {
    return {
      isEmpty: false,
      isSubmitting: false,
      isLoading: false,
      checkedRows: [],
      modifiedRows: [],
      myData: [],
      storedGoals: [],
      selected: null,
      formWeezyId: "",
      formThemeId: "",
      formVolume: 2,
      formDailySalesGoal: "",
      formIsActive: false,
      formIsVibeSensorActive: false,
      maxTime: "",
      isErrorDisplayed: false,
      isLoading: true,
      managerWeezyId: undefined,
      currentPage: 1,
      perPage: 10
    };
  },
  watch: {
    formWeezyId: function(newVal, oldVal) {
      if (!this.isWeezyActive(newVal)) {
        this.warningToast(
          "Vous devez d'abord activer le Weezy pour activer un Objectif"
        );
      }
    },
    goals: function(newVal, oldVal) {
      this.storedGoals = JSON.parse(JSON.stringify(this.goals));
      this.myData = JSON.parse(JSON.stringify(this.storedGoals)).sort(
        (a, b) =>
          new Date(b.creation_date_time) - new Date(a.creation_date_time)
      );
      this.isLoading = false;
      this.storedSales = JSON.parse(JSON.stringify(this.myData));

      for (var i = 0; i < this.myData.length; i++) {
        this.myData[i].activation_date_time = this.timeFormatter(
          this.myData[i].activation_date_time
        );
      }
      if (!this.isAdmin[0]) {
        this.formWeezyId = this.isAdmin[1];
      }
    }
  },
  methods: {
    resetModifiedArray() {
      setTimeout(() => {
        this.storedGoals = JSON.parse(JSON.stringify(this.goals));
        this.modifiedRows = [];
        this.checkedRows = [];
        this.resetMyData;
      }, 100);
    },
    resetMyData() {
      this.myData = [
        {
          id: "",
          creation_date_time: "",
          is_reached: "",
          is_active: false,
          is_vibe_sensor_active: false,
          sound_volume: "0",
          weezy_id: "",
          theme_id: "",
          daily_sales_goal: "",
          campaign_id: ""
        }
      ];
      this.resetFormData();
    },
    dateFormatter(value) {
      var date = new Date(value);
      var years = date.getFullYear();
      var months = this.leadZero(date.getMonth() + 1);
      var days = this.leadZero(date.getDate());
      return days + "-" + months + "-" + years;
    },
    timeFormatter(value) {
      var date = new Date(value);
      return new Date(
        date.setHours(date.getHours() - date.getTimezoneOffset() / 60)
      );
    },
    leadZero(n) {
      return n > 9 ? n : "0" + n;
    },
    deleteChecked() {
      this.$parent.isDeleteConfirmationModalActive = true;
    },
    confirmDelete() {
      this.$parent.deleteCheckedRows(this.checkedRows);
      this.checkedRows = [];
    },
    toggleModified(raaw) {
      // Disallow multiple active goals per weezy
      if (raaw.is_active) {
        for (var i = 0; i < this.myData.length; i++) {
          if (
            this.myData[i].is_active &&
            raaw.weezy_id == this.myData[i].weezy_id &&
            raaw.id != this.myData[i].id
          ) {
            this.myData[i].is_active = false;
          }
        }
      }

      var modified = false;
      this.modifiedRows.push(raaw);
      for (var j = 0; j < this.modifiedRows.length; j++) {
        var row = this.modifiedRows[j];
        for (var i = 0; i < this.storedGoals.length; i++) {
          var goal = this.storedGoals[i];
          if (goal.id == row.id) {
            if (
              !(
                (goal.activation_date_time ==
                  JSON.parse(JSON.stringify(row.activation_date_time)) ||
                  goal.activation_date_time == null) &&
                goal.is_active == row.is_active &&
                goal.is_vibe_sensor_active == row.is_vibe_sensor_active &&
                goal.sound_volume == row.sound_volume &&
                goal.theme_id == row.theme_id &&
                goal.weezy_id == row.weezy_id &&
                goal.daily_sales_goal == row.daily_sales_goal
              )
            ) {
              let currDate = new Date();
              let goalActivationDate = new Date(row.activation_date_time);
              // xxTimeString = 09:50 --> "950"
              //      or        10:01 --> "1001"
              let rowTimeString =
                goalActivationDate.getHours().toString() +
                (goalActivationDate.getMinutes() > 9
                  ? goalActivationDate.getMinutes()
                  : "0" + goalActivationDate.getMinutes()
                ).toString();
              let rowTime = parseInt(rowTimeString);
              let currTimeString =
                currDate.getHours().toString() +
                (currDate.getMinutes() > 9
                  ? currDate.getMinutes()
                  : "0" + currDate.getMinutes()
                ).toString();
              let currTime = parseInt(currTimeString);
              if (
                currDate.getMonth() == goalActivationDate.getMonth() &&
                currDate.getFullYear() == goalActivationDate.getFullYear() &&
                currDate.getDate() == goalActivationDate.getDate() &&
                currTime < rowTime
              ) {
                if (!this.isErrorDisplayed) {
                  this.cancelModifications();
                  this.$parent.errorToast("Heure d'activation du futur !");
                  this.isErrorDisplayed = true;
                  // AVoid displaying toast if one is arleady being displayed
                  setTimeout(() => {
                    this.isErrorDisplayed = false;
                  }, 1000);
                }
              }
              modified = true;
            }
          }
        }
        if (!modified) {
          this.modifiedRows = [];
        }
      }
    },
    validateModifications() {
      if (this.checkable) {
        this.$parent.modifyRows(this.modifiedRows);
      }
    },
    cancelModifications() {
      if (this.checkable) {
        this.$parent.getGoals();
      } else {
        this.resetMyData();
        this.$parent.hideAdd();
      }
    },
    campaignName(FromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        var weezy = this.weezys[i];
        if (weezy.id == FromWeezyId) {
          for (var j = 0; j < this.campaigns.length; j++) {
            if (weezy.campaign_id == this.campaigns[j].id) {
              return this.campaigns[j].name;
            }
          }
        }
      }
    },
    submitFormData() {
      if (
        this.formVolume == "" ||
        this.formDailySalesGoal == "" ||
        this.formWeezyId == "" ||
        this.formThemeId == ""
      ) {
        this.$parent.errorToast("Merci de remplir tous les champs");
      } else if (!this.isSubmitting) {
        this.isSubmitting = true;
        this.$parent.addNewRow({
          sound_volume: this.formVolume,
          weezy_id: this.formWeezyId,
          theme_id: this.formThemeId,
          daily_sales_goal: this.formDailySalesGoal,
          is_active: this.formIsActive,
          is_vibe_sensor_active: this.formIsVibeSensorActive
        });
      }
    },
    dismissForm() {
      this.$parent.isDeleteConfirmationModalActive = false;
      this.$parent.isComponentModalActive = false;
      this.resetFormData();
    },
    resetFormData() {
      this.formVolume = 2;
      this.formDailySalesGoal = "";
      this.formIsActive = false;
      this.formIsVibeSensorActive = "";
      this.formThemeId = "";
      if (this.isAdmin[0]) {
        this.formWeezyId = "";
      }
    },
    getColor(row) {
      let percent = (row.sales.length / row.daily_sales_goal) * 100;
      if (percent >= 100) {
        return "color: #0000BB;";
      } else if (percent >= 90) {
        return "color: #009900;";
      } else if (percent >= 70) {
        return "color: #669900;";
      } else if (percent >= 50) {
        return "color: #AAAA00;";
      } else if (percent >= 25) {
        return "color: #BB4400;";
      } else {
        return "color: #DD0000;";
      }
    },
    getVolume(value) {
      switch (value.toString()) {
        case "1":
          return "Min.";
        case "2":
          return "Moy";
        case "3":
          return "Max";
      }
    },
    sortByCreation(a, b, isAsc) {
      if (isAsc) {
        return new Date(b.creation_date_time) - new Date(a.creation_date_time);
      } else {
        return new Date(a.creation_date_time) - new Date(b.creation_date_time);
      }
    },
    sortByProgression(a, b, isAsc) {
      if (isAsc) {
        return (
          b.sales.length / b.daily_sales_goal -
          a.sales.length / a.daily_sales_goal
        );
      } else {
        return (
          a.sales.length / b.daily_sales_goal -
          b.sales.length / a.daily_sales_goal
        );
      }
    },
    getMaxTime(goal) {
      var currDate = new Date();
      var goalDate = new Date(goal.creation_date_time);
      // If goal to modify is today, then max time is current time
      if (
        currDate.getMonth() == goalDate.getMonth() &&
        currDate.getFullYear() == goalDate.getFullYear() &&
        currDate.getDate() == goalDate.getDate()
      ) {
        var maxTime = new Date();
        maxTime.setHours(maxTime.getHours());
        maxTime.setMinutes(maxTime.getMinutes());
        return maxTime;
      } else {
        return null;
      }
    },
    isWeezyActive(weezyId) {
      var res = false;
      for (var i = 0; i < this.weezys.length; i++) {
        if (this.weezys[i].id == weezyId) {
          res = this.weezys[i].is_active;
          if (!res) {
            this.formIsActive = false;
          }
        }
      }
      return res;
    },
    warningToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-warning"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.b-input-number {
  width: 59px;
}

.b-table {
  overflow-y: visible;
}

.button-add-campaign {
  float: right;
  padding-right: 10%;
}

.action-button {
  float: right;
  padding-right: 10px;
}

.modal-line {
  display: flex;
  justify-content: space-between;
}

.modal-input-field {
  width: 175px;
  padding-left: 0px;
}

.b-modal-input-number {
  width: 100px;
}

.b-modal-select-field {
  width: 200px;
}

.action-buttons {
  margin-top: 10px !important;
}
</style>